import popupCloseComponent from "./popup-close-component.js";
import popupComponent from "./popup-component.js";
import popupContentComponent from "./popup-content-component.js";
import popupTriggerComponent from "./popup-trigger-component.js";

const addComponents = (editor, opts) => {
  const componentOptions = opts.components;

  popupCloseComponent(editor, componentOptions);
  popupContentComponent(editor, componentOptions);
  popupComponent(editor, componentOptions);
  popupTriggerComponent(editor, componentOptions);
}

export default addComponents;